/*
view-inputpopup.js
*/

/*
This is an example of the popup structure:
<div class="menu notify">
    <div class="binary-question u-box-bg u-pos-c u-b-radius grid-u-sm-3-4">
        <h2 class="notify__main-title u-mb0 u-text-c">TITLE</h2>
        <p class="notify__p u-m0 u-pl2 u-pr2 u-text-c">TEXT</p>

        <form>
            <fieldset class="input-wrap u-relative u-p2" data-content-error="XXXXX">
                <label for="set-limit-input" class="input-wrap__label">SET DAILY LIMIT</label>
                <input type="number" id="set-daily-limit" placeholder="AMOUNT" class="input-wrap__input input-wrap__input--placeholder">
                <span class="input-wrap__error-display js-input-error-display"></span>
            </fieldset>
        </form>
        <div class="binary-question__button-container u-relative grid-r">
            <div class="binary-question__no grid-u-sm-1-2">
                <button class="btn">CLOSE</button>
            </div>
            <div class="or u-absolute u-b-radius-round u-text-c u-div-c">OR</div>
            <div class="binary-question__yes grid-u-sm-1-2">
                <button class="btn">YES</button>
            </div>
        </div>
    </div>
</div>
*/

/* this is used for first time uk deposit for setting daily limit */
import core from '../../common/lib/core.js';
import viewTextkeys from './../../commonview/lib/view-textkeys.js';

const create = core.create; // creates basic elements not inserted into the dom

function createPopUpWrapper() {
	return create({
		type: 'div',
		class: 'js-payment-set-limit-wrapper notify u-absolute u-pos-tl0'
	});
}

function createTitle(txt) {
	const elm = create({
		type: 'h2',
		class: 'notify__main-title u-mb0 u-text-c js-payment-set-limit-title'
	});
	if (txt) {
		elm.innerHTML = txt;
	}
	return elm;
}

function createMessage(txt) {
	const elm = create({
		type: 'p',
		class: 'u-pl2 u-pr2 u-text-c js-payment-set-limit-message'
	});
	if (txt) {
		elm.innerHTML = txt;
	}
	return elm;
}

function createForm() {
	return create({
		type: 'form'
	});
}

function createFieldset() {
	return create({
		type: 'fieldset',
		class: 'input-wrap u-relative u-p2'
	});
}

function createInputLimitLabel(txt) {
	const elm = create({
		type: 'label',
		class: 'input-wrap__label',
		for: 'set-limit-input'
	});
	if (txt) {
		elm.innerHTML = txt;
	}
	return elm;
}

function createInputLimitField(placeholder) {
	return create({
		type: 'input',
		class: 'payment__input-set-limit-input input-wrap__input u-mb2 js-payment-set-limit-input',
		name: 'limit',
		'input-type': 'tel',
		placeholder
	});
}

function createInputLimitFeedback(txt) {
	const elm = create({
		type: 'label',
		class: 'input-wrap__label',
		for: 'set-limit-input'
	});
	if (txt) {
		elm.innerHTML = txt;
	}
	return elm;
}

function createButtonWrapper() {
	return create({
		type: 'div',
		class: 'binary-question__button-container u-relative grid-r'
	});
}

function createCancelButtonWrapper() {
	return create({
		type: 'div',
		class: 'binary-question__no grid-u-sm-1-2'
	});
}

function createCancelbutton(eventFilter, txt) {
	const cName = `${eventFilter} btn`;
	const elm = create({
		type: 'button',
		class: cName
	});
	if (txt) {
		elm.innerHTML = txt;
	}
	return elm;
}

function createConfirmButtonWrapper() {
	return create({
		type: 'div',
		class: 'binary-question__yes grid-u-sm-1-2'
	});
}

function createConfirmButton(eventFilter, txt) {
	const cName = `${eventFilter} btn`;
	const elm = create({
		type: 'button',
		class: cName
	});
	if (txt) {
		elm.innerHTML = txt;
	}
	return elm;
}

function createButtonSeparator(txt) {
	const elm = create({
		type: 'div',
		class: 'or u-absolute u-b-radius-round u-text-c u-div-c'
	});
	if (txt) {
		elm.innerHTML = txt;
	}
	return elm;
}

function assembleElements(elements, textkeysObj, classNameEventFilter) {
	/* create elements if not already existing */
	// elements.wrap = (elements.wrap || document.querySelector('.js-global-notification'));
	const elms = {};
	elms.wrap = (elements.wrap || document.querySelector('.js-global-notification'));

	if (elms.wrap) {
		elms.popUpWrapper = (elements.popUpWrapper || createPopUpWrapper());
		elms.title = (elements.title || createTitle(textkeysObj['set-limit-title']));
		elms.message = (elements.message || createMessage(textkeysObj['set-limit-message']));
		elms.form = (elements.form || createForm());
		elms.fieldset = (elements.fieldset || createFieldset());
		elms.inputLimitLabel = (elements.inputLimitLabel || createInputLimitLabel(textkeysObj['set-limit-amount-label']));
		elms.inputLimitField = (elements.inputLimitField || createInputLimitField(textkeysObj['set-limit-amount-label']));
		elms.inputLimitFeedback = (elements.inputLimitFeedback || createInputLimitFeedback(textkeysObj['set-limit-amount-feedback']));
		elms.buttonWrapper = (elements.buttonWrapper || createButtonWrapper());
		elms.cancelButtonWrapper = (elements.cancelButtonWrapper || createCancelButtonWrapper());
		elms.cancelButton = (elements.cancelButton || createCancelbutton(classNameEventFilter, textkeysObj['set-limit-not-now']));
		elms.buttonSeparator = (elements.buttonSeparator || createButtonSeparator(textkeysObj.or));
		elms.confirmButtonWrapper = (elements.confirmButtonWrapper || createConfirmButtonWrapper());
		elms.confirmButton = (elements.confirmButton || createConfirmButton(classNameEventFilter, textkeysObj['set-limit-ok']));

		/* hierarchy */
		elms.popUpWrapper.appendChild(elms.message);
		elms.popUpWrapper.appendChild(elms.title);
		elms.popUpWrapper.appendChild(elms.form);
		elms.popUpWrapper.appendChild(elms.buttonWrapper);
		elms.form.appendChild(elms.fieldset);
		elms.fieldset.appendChild(elms.inputLimitLabel);
		elms.fieldset.appendChild(elms.inputLimitField);
		elms.fieldset.appendChild(elms.inputLimitFeedback);
		elms.buttonWrapper.appendChild(elms.cancelButtonWrapper);
		elms.buttonWrapper.appendChild(elms.buttonSeparator);
		elms.buttonWrapper.appendChild(elms.confirmButtonWrapper);
		elms.cancelButtonWrapper.appendChild(elms.cancelButton);
		elms.confirmButtonWrapper.appendChild(elms.confirmButton);
		// add to DOM, prepend in global notification wrapper
		// elements.wrap.insertBefore(elements.popUpWrapper, elements.wrap.firstChild);
		elms.wrap.insertBefore(elms.popUpWrapper, elms.wrap.firstChild);
	}
	return elms;
}

function mainHandler(e, onEventCb, eventFilterSeparatorClassname) {
	const eventFilterSelector = `.${eventFilterSeparatorClassname}`;

	function cb(p) {
		p.e.stopPropagation();
		p.e.preventDefault();
		onEventCb();
	}
	/* If the last argument is set to 'true', the handler function runs the callback if the .fkn_filter element or any of its children (#content_A,#content_B,#inner_content) is clicked */
	core.handle(e, eventFilterSelector, cb, true);
}

function addListeners(elm, cbOnEvent, eventFilter, eventType) {
	function handleCreator(e) {
		mainHandler(e, cbOnEvent, eventFilter);
	}
	core.addListener(elm, eventType, handleCreator);
	return handleCreator;
}

function removeListeners(elm, handler, eventType) {
	if (elm) {
		core.removeListener(elm, eventType, handler);
	}
}

function show(elm, classnameShow, classnameHide) {
	if (classnameHide) {
		core.removeClass(elm, classnameHide);
	}
	if (classnameShow) {
		core.addClass(elm, classnameShow);
	}
}

function hide(elm, classnameShow, classnameHide) {
	if (classnameShow) {
		core.removeClass(elm, classnameShow);
	}
	if (classnameHide) {
		core.addClass(elm, classnameHide);
	}
}

export default {
	create(p) {
		let elements = {};
		const classNameEventFilter = 'js-eventfilter-viewinputpopup';
		const openGlobalClassName = 'global-notification--is-open';
		const openClassName = 'notify--is-open';
		const mainEventType = 'click';
		const textkeysObj = viewTextkeys.depositflow();
		let cleanRemoveReset = null;
		const cbConf = (p.confirmCb || function empty() {});
		const cbReject = (p.rejectCb || function empty() {});
		elements = assembleElements(elements, textkeysObj, classNameEventFilter);
		const confirmCb = function temp() {
			const val = elements.inputLimitField.value;
			cbConf(val);
			hide(elements.wrap, openGlobalClassName);
			hide(elements.popUpWrapper, openClassName);
			// cleanRemoveReset();
		};
		const denyCb = function temp() {
			cbReject();
			hide(elements.wrap, openGlobalClassName);
			hide(elements.popUpWrapper, openClassName);
			// cleanRemoveReset();
		};
		const handlerMain = addListeners(elements.wrap, confirmCb, classNameEventFilter, mainEventType);
		// const handlerMain = addListeners(elements.confirmButton, confirmCb, classNameEventFilter, mainEventType);
		const handlerAlt = addListeners(elements.cancelButton, denyCb, classNameEventFilter, mainEventType);

		cleanRemoveReset = function fkn() {
			hide(elements.wrap, openGlobalClassName);
			hide(elements.popUpWrapper, openClassName);
			removeListeners(elements.confirmButton, handlerMain, mainEventType);
			removeListeners(elements.cancelButton, handlerAlt, mainEventType);
			elements = core.deleteElementsInObjectExcept(elements, ['wrap', 'before', 'textkeys'], 'view-inputpopup:363');
		};
		// core.addListener(elements.confirmButton, 'click', confirmClickHandler);
		// core.addListener(elements.cancelButton, 'click', cancelClickHandler);

		return {
			wrap: elements.wrap,
			show() {
				show(elements.wrap, openGlobalClassName);
				show(elements.popUpWrapper, openClassName);
				// openWrappers(elements);
			},
			hide() {
				hide(elements.wrap, openGlobalClassName);
				hide(elements.popUpWrapper, openClassName);
				// closeWrappers(elements);
			},
			update() {},
			close() {
				cleanRemoveReset();
			}

		};
	}
};



// WEBPACK FOOTER //
// ./mobile-core/src/payment/commonview/lib/view-inputpopup.js